import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { PageComponent } from '../page/page.component';
import { GlobalsService } from '../../services/globals.service';
import { StorageService } from '../../services/storage.service';
import { ViasConnectionService, ViasResponse } from '../../services/vias-connection.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { PageMeta, ResponseField, ResponseFieldDataSourceType, PageMetaService } from '../../services/page-meta.service';
import { DataGridEvent } from '../datagrid/datagrid.component';
import { ButtonBarItem } from '../buttonbar/buttonbar.component';
import { FilterOptions, DataGridColumn } from '../datagrid/datagrid.component';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogFields } from '../../services/vias-dialog.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { FormEvent, FormItem, FormOption, ServiceCall } from '../form/FormItem';
import { FieldTypes } from '../../FieldTypes';
import { AlertType } from '../../services/vias-alert.service';

@Component({
  selector: 'vias-default-report-page',
  templateUrl: './default-report-page.component.html',
  styleUrls: ['./default-report-page.component.scss']
})
export class DefaultReportPageComponent extends PageComponent {
  formRefx;
  @ViewChild('form', { static: false }) set formRef(form: ElementRef | null) {
    if (!form) { return; }
    this.afterFormInit(form);
  }

  formSubmitFields: object = {};

  tableAddDialogRun: ($event) => void;

  constructor(
    protected storage: StorageService,
    protected globals: GlobalsService,
    protected viasService: ViasConnectionService,
    protected next: ActivatedRoute,
    protected route: Router,
    protected translate: TranslateService,
    public tableDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) protected dialogData: {} = {},
    protected dialogRef: MatDialogRef<DefaultReportPageComponent>,
  ) {
    super(storage, globals, viasService, next, route, translate, dialogData);
    this.hasDatagrid = true;
    this.hasEditForm = true;
  }
  afterFormInit(form): void {
    // formRef init olunca set ediliyor, yokdsa null
    this.formRefx = form;
    form.formChange.subscribe(changed => {
      // item bul
      const item: FormItem = this.formItems.find(e => e.name === changed.itemName);

      if (item.onChangedServiceCall !== undefined) {
        const csca: ServiceCall[] = item.onChangedServiceCall;
        csca.forEach(csc => {
          const data: object = {};
          data[csc.data] = changed.val;
          this.viasService.send(
            csc.pid,
            csc.aid,
            data
          )
            .then(r => {
              console.log(r);
              if (r.error) {
                this.globals.handleErrors(r.error);
              }
              if (r.data !== undefined) {
                if (r.data[csc.returnField] !== undefined) {
                  // baska alana deger olarak gir
                  // serviceWorkStatusEditMode bu alan true ise edit modunda da çalışacak
                  // tslint:disable-next-line: triple-equals
                  if (csc.otherFieldVal !== undefined && (csc.serviceWorkStatusEditMode == true || this.loadAid != 3)) {
                    form.form.get(csc.otherFieldVal).setValue(r.data[csc.returnField]);
                    // baska alana data source
                  } else if (csc.otherFieldDataSource !== undefined) {
                    const fItem: FormItem = form.formItems.find(e => e.name === csc.otherFieldDataSource);
                    const res = r.data[csc.returnField];
                    const opt: FormOption[] = [];
                    for (const s in res) {
                      if (s !== undefined) {
                        opt.push({
                          label: res[s][fItem.optionsDataLabelField],
                          data: res[s][fItem.optionsDataIdField]
                        });
                      }
                    }
                    fItem.options = opt;
                  }
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
      }
      // onchange fonk varsa calistir
      if (item.onChangedFunc !== undefined) {
        console.log(item.onChangedFunc);
        item.onChangedFunc(changed.val, this);
      }
    });
  }
  formItemClickHandler($event: FormItem): void {
    if ($event.iconClick !== undefined) {
      $event.iconClick(this,
        this.storage, this.globals, this.viasService, this.next, this.route, this.translate, this.tableDialog
      );
    }
  }
  formChangeHandler($event: object): void {
    if (this.pageMeta.formChangeFunction !== undefined) {
      if (this.pageMeta.formChangeFunctionItems !== undefined) {
        this.pageMeta.formChangeFunctionItems.forEach(fi => {
          if ($event['itemName'] === fi) {
            this.pageMeta.formChangeFunction($event, this);
          }
        });
      }
    }
    console.log($event);
  }

  formTableEditHandler($event: any): void {
    this.tableAddDialogRun($event);
  }
  formSubmitHandler($event: FormEvent): void {
    console.log($event);
    console.log(this.formRefx);

    if (this.pageMeta.formBeforeSubmitFunction !== undefined) {
      this.pageMeta.formBeforeSubmitFunction(this, this.formRefx.form,
        this.storage, this.globals, this.viasService, this.next, this.route, this.translate
      );
    } else {
      const sendData: object = {};
      this.formItems.forEach(fi => {
        let val = $event[fi.name];
        if (fi.type === FieldTypes.DateCombo) {
          const d = new Date(val);
          val = d.getTime() / 1000;
        }
        sendData[fi.name] = val;
      });
      for (const key in this.formSubmitFields) {
        if (this.formSubmitFields[key]) {
          sendData[key] = this.formSubmitFields[key];
        }
      }
      this.viasService.send(this.pid, this.submitAid, sendData).then(
        response => {
          // super.viasServiceHandler(response);
          this.globals.viasAlert.show('successful', AlertType.Success);
          this.viasSubmitServiceHandler(response);
        },
        err => {
          this.globals.handleErrors([err]);
          // alert(err);
          // console.log(err);
        });
    }
  }
  viasSubmitServiceHandler(response: ViasResponse): void {
    if (response.error !== null && response.error !== undefined && response.error.length > 0) {
      this.globals.handleErrors(response.error);
    } else {
      if (this.pageMeta.formAfterSubmitFunction !== undefined) {
        this.pageMeta.formAfterSubmitFunction(response,
          this.storage, this.globals, this.viasService, this.next, this.route, this.translate
        );
      } else {
        switch (response.return_action) {
          // kendini guncelle
          case 'refresh':
          case 'refresh_self':
            this.viasListOneService();
            break;
          // formu kapat arkadaki sayfayi guncelle
          default:
          case '':
          case 'success':
            this.route.navigate(
              ['/' + this.moduleName + '/' + this.pageMeta.listPageName]
            );
            break;
        }
      }
    }
  }
  viasListOneService(): void {
    let sendData: object = this.data$;
    if (this.pageMeta.editInitDataFields !== undefined) {
      sendData = {
        ...sendData,
        ...this.pageMeta.editInitDataFields
      };
    }
    const pidx = this.editPid !== undefined && this.editPid > 0 ? this.editPid : this.pid;

    // this.pageMeta.inspectAid
    // this.viasService.send(pidx, this.aid, sendData).then(
    this.viasService.send(pidx, this.pageMeta.inspectAid, sendData).then(
      response => {
        if (response.error !== null && response.error !== undefined && response.error.length > 0) {
          this.globals.handleErrors(response.error);
        }
        this.viasServiceHandler(response);
      },
      err => {
        this.globals.handleErrors([err]);
      });

  }

}
